module.exports = __webpack_public_path__ + "static/media/logo-black-old.16bb1fb6.svg";